import React from 'react'
import PropTypes from 'prop-types'

import { withRouter } from 'react-router-dom';

import { Container, Button } from 'semantic-ui-react';
import { Section, Table, InfosBar, Text } from 'components';

import { GenericScene } from 'scenes';

import { ModalDevice } from 'modals';

import { BreadcrumbHelper, Typeof } from 'utils';

import moment from 'moment';

const DEVICES_PER_PAGE = 10;

class DeviceListScene extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      devices: props.devices,
      criteria: '',
      showCreateModal: false
    };

    this.handleSearch = this.handleSearch.bind(this);

    this.toggleCreateModal = this.toggleCreateModal.bind(this);
    this.handleCreateModalClose = this.handleCreateModalClose.bind(this);

    this.handleSelect = this.handleSelect.bind(this);
  }

  componentWillMount() {

    BreadcrumbHelper.reset();
    BreadcrumbHelper.push('Accueil', '/');
    BreadcrumbHelper.push('Appareils installés');
    BreadcrumbHelper.flush();

    // Restore last search if URL parameter is present
    const urlParams = new URLSearchParams(this.props.location.search);
    const searchParam = urlParams.get('search');

    if (searchParam === 'last') {
      const lastSearch = localStorage.getItem('devices_last_search');
      if (lastSearch) {
        this.setState({ criteria: lastSearch });
      }
    } else {
      // Clear search criteria when accessing /devices directly
      this.setState({ criteria: '' });
    }
  }

  componentDidUpdate(prevProps) {
    // Check if location search parameter changed
    if (prevProps.location.search !== this.props.location.search) {
      const urlParams = new URLSearchParams(this.props.location.search);
      const searchParam = urlParams.get('search');

      if (searchParam === 'last') {
        const lastSearch = localStorage.getItem('devices_last_search');
        if (lastSearch) {
          this.setState({ criteria: lastSearch });
        }
      } else {
        // Clear search criteria when accessing /devices directly
        this.setState({ criteria: '' });
      }
    }
  }

  handleSearch(criteria) {

    this.setState({
      criteria: criteria
    });

    // Save last search in localStorage
    if (criteria && criteria.trim().length > 0) {
      localStorage.setItem('devices_last_search', criteria);
    }
  }

  handleSelect(device) {

    //Navigate to device page
    this.props.history.push(`/devices/${device.id}`);
  }

  toggleCreateModal() {
    this.setState({
      showCreateModal: !this.state.showCreateModal
    });
  }

  handleCreateModalClose(create) {

    if(Typeof.object(create)) {
      create.remotes = [];

      this.state.devices.push(create);
    }

    this.toggleCreateModal();
  }

  render() {

    const { devices } = this.state;

    let columns = [
      {
        id: 'id',
        header: '#',
        value: (device) => device.id,
        fit: true,
      },
      {
        id: 'name',
        header: 'Nom',
        value: (device) => device.name,
      },
      {
        id: 'address',
        header: 'Adresse',
        value: (device) => `${device.address}, ${device.zip_code} ${device.city}`
      },
      {
        id: 'mac_address',
        header: 'Adresse MAC',
        value: (device) => <Text style="mono uppercase">{device.mac_address}</Text>,
        fit: true
      },
      {
        id: 'remotes',
        header: 'Télécommande(s)',
        value: (device) => device.remotes.length,
        fit: true,
      },
      {
        id: 'last_used',
        header: 'Dernière synchro',
        value: (device) => device.last_used,
        sort: (a, b, direction) => {
          const dateA = a.last_used;
          const dateB = b.last_used;

          // Handle null/undefined values - always push them to the end
          if (!Typeof.string(dateA) && !Typeof.string(dateB)) return 0;
          if (!Typeof.string(dateA)) return 1;
          if (!Typeof.string(dateB)) return -1;

          // Compare dates chronologically
          const comparison = moment(dateA).valueOf() - moment(dateB).valueOf();

          // Apply direction
          return direction === 'descending' ? -comparison : comparison;
        },
        render: (device) => {
          return device.last_used ? moment(device.last_used).format('DD/MM/YYYY HH:mm:ss') : 'N/A';
        },
        fit: true,
      },
      {
        id: 'nb_used',
        header: 'Jetons utilisés',
        value: (device) => device.nb_used || 0,
        render: (device) => {
          return (
            <Text style="mono">
              {device.nb_used || 0}
            </Text>
          )
        },
        fit: true,
      }
    ];

    return (
      <GenericScene>

        <Container>

          <Section title="Liste des appareils installés" onSearch={this.handleSearch} criteria={this.state.criteria} actions={[

            // Add device
            <Button icon="add" content="Ajouter" onClick={this.toggleCreateModal} />
          ]}>

            {devices.length > 0 ? (

              <React.Fragment>

                {/* Number of available devices */}
                <InfosBar mode="column">
                  <span>{devices.length > 1 ? `${devices.length} appareils disponibles` : '1 appareil disponible'}</span>
                </InfosBar>

                {/* Devices list */}
                <Table columns={columns}
                  criteria={this.state.criteria}
                  items={devices}
                  itemsPerPage={DEVICES_PER_PAGE}
                  onSelect={this.handleSelect}
                  messageEmpty="Aucun appareil ne correspond à votre recherche"
                  sort="id"
                  direction="descending"
                />

              </React.Fragment>

            ) : (

              // No device available
              <InfosBar mode="row">
                <span>Aucune device disponible</span>
              </InfosBar>

            )}

          </Section>

        </Container>

        {/* Modal create customer */}
        {this.state.showCreateModal &&
          <ModalDevice onClose={this.handleCreateModalClose} />
        }

      </GenericScene>
    );
  }
}

export default withRouter(DeviceListScene);
